import type { TaskExample } from '@frontend/api-types';
import { CardContainer, CardContent, CardHeader, Icon, Text, XStack, YStack } from '@frontend/web-react';
import { useAnalytics, useCreateTaskContext } from '@frontend/web/hooks';

type TrendingTaskCardProps = {
  example: TaskExample;
};

export const TrendingTaskCard = ({ example }: TrendingTaskCardProps) => {
  const { description, exampleType, id, name } = example;
  const { openCreateTaskModal } = useCreateTaskContext();
  const { track } = useAnalytics();

  const handleClick = async () => {
    track({
      data: { exampleId: example.id, exampleType: example.exampleType, taskName: example.name },
      event: 'exampleSelected',
      topic: 'examples',
    });

    openCreateTaskModal({
      initialData: {
        description: description,
        exampleId: id,
        name: name,
        ...(exampleType && { exampleType: exampleType }),
      },
    });
  };

  return (
    <CardContainer className="gap-lg justify-between" onClick={handleClick}>
      <YStack className="gap-lg">
        {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
        {/* @ts-expect-error */}
        <CardHeader title={name} titleTextProps={{ lineClamp: 2 }} />
        {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
        {/* @ts-expect-error */}
        <CardContent description={description} descriptionTextProps={{ lineClamp: 2 }} />
      </YStack>
      <XStack className="gap-xs px-sm py-xs items-center justify-end">
        <Text color="secondary" type="h5">
          Create task
        </Text>
        <Icon color="secondary" name="IconArrowRight" size="md" />
      </XStack>
    </CardContainer>
  );
};
